import { ChatPlaceholder } from '@client/components/dm/ChatPlaceholder';
import { Inbox } from '../../../components/dm/Inbox';
import { useDM } from '../../../hooks/use-dm';
import { Typography } from '@mui/material';

export const InboxContainer = ({ influencerId }: { influencerId: number }) => {
  const { userId, chatClient, isLoading } = useDM({
    asInfluencerId: influencerId,
  });

  if (isLoading || !chatClient) {
    return (
      <div>
        <Typography variant="h1">Inbox</Typography>
        <ChatPlaceholder />
      </div>
    );
  }

  return (
    <div className="h-full max-w-[935px]">
      <Inbox userId={userId} client={chatClient} />
    </div>
  );
};
